module.exports = __webpack_public_path__ + "img/borderOctagonalWhite.c323ebc8.svg";